"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.correctMark = exports.mapPrescribeMarkToAnswer = exports.isPrescribeAnswer = void 0;
const models_1 = require("../models");
const object_1 = require("./object");
function createHashMap(arr) {
    const map = new Map();
    for (const innerArr of arr) {
        const sortedInnerArr = innerArr.slice().sort();
        const key = sortedInnerArr.join('|');
        map.set(key, (map.get(key) || 0) + 1);
    }
    return map;
}
function isPrescribeAnswer(data) {
    return Object(data).hasOwnProperty('dose');
}
exports.isPrescribeAnswer = isPrescribeAnswer;
function mapPrescribeMarkToAnswer(obj) {
    if (isPrescribeAnswer(obj)) {
        return {
            drugId: obj.drug.value,
            doseId: obj.dose.value,
            durationId: obj.duration.value,
            frequencyId: obj.frequency.value,
            routeId: obj.route.value,
        };
    }
    return {
        drugId: obj.drugId,
        doseId: obj.doseId,
        durationId: obj.durationId,
        frequencyId: obj.frequencyId,
        routeId: obj.routeId,
    };
}
exports.mapPrescribeMarkToAnswer = mapPrescribeMarkToAnswer;
function correctMark(mark) {
    const data = {
        correct: false,
        incorrect: false,
        correctIndex: -1,
    };
    if (!mark || !mark.mark) {
        return data;
    }
    try {
        const qKeys = Object.keys(mark.question);
        const answerKey = qKeys.find((k) => k.toLowerCase().indexOf('answer') !== -1) || 'answer';
        const answer = mark.question[answerKey];
        const flatAnswer = answer[0];
        const jsonAnswer = typeof mark.mark === 'string' ? JSON.parse(mark.mark) : mark.mark;
        const flatAttempt = jsonAnswer[0];
        if ([
            models_1.EQuestionType.SINGLE_BEST_ANSWER,
            models_1.EQuestionType.SBA_WITH_MULTIPLE_CHOICES,
            models_1.EQuestionType.VERBAL_VERACITY,
            models_1.EQuestionType.VERBAL_READING_COMPREHENSION,
            models_1.EQuestionType.DECISION_MAKING_SBA,
            models_1.EQuestionType.QUANTITATIVE_REASONING_SBA,
            models_1.EQuestionType.SJT_SINGLE_CHOICE,
        ].includes(mark.question.typeId)) {
            const answer = flatAnswer;
            const attempt = flatAttempt;
            if (answer === attempt) {
                data.correct = true;
            }
            else {
                data.incorrect = true;
            }
        }
        else if (models_1.EQuestionType.QUESTION_ANSWER === mark.question.typeId) {
            const answer = flatAnswer.dose
                .toLowerCase()
                .replace(/\s/g, '');
            let attempt = '';
            if (flatAttempt) {
                attempt = flatAttempt.toLowerCase().replace(/\s/g, '');
            }
            if (answer === attempt) {
                data.correct = true;
            }
            else {
                data.incorrect = true;
            }
        }
        else if ([
            models_1.EQuestionType.MULTIPLE_ANSWERS,
            models_1.EQuestionType.DECISION_MAKING_YES_NO,
        ].includes(mark.question.typeId)) {
            const [answerA, answerB] = answer.map((x) => x.sort());
            let [attemptA, attemptB] = [[], []];
            if (Array.isArray(jsonAnswer) &&
                jsonAnswer.length === 2 &&
                Array.isArray(jsonAnswer[0]) &&
                Array.isArray(jsonAnswer[1])) {
                [attemptA, attemptB] = jsonAnswer.map((x) => x.sort());
            }
            if (answerA.length !== attemptA.length ||
                answerB.length !== attemptB.length) {
                data.incorrect = true;
            }
            else if (attemptA.every((x, i) => x === answerA[i]) &&
                attemptB.every((x, i) => x === answerB[i])) {
                data.correct = true;
            }
            else {
                data.incorrect = true;
            }
        }
        else if (models_1.EQuestionType.PRESCRIPTION_ANSWER === mark.question.typeId) {
            let foundCorrect = false;
            let index = 0;
            if (typeof flatAttempt === 'object' &&
                Object.keys(flatAttempt).length > 0) {
                const answers = answer.map(mapPrescribeMarkToAnswer);
                const attempt = mapPrescribeMarkToAnswer(flatAttempt);
                for (const answer of answers) {
                    if ((0, object_1.compareObjects)(answer, attempt)) {
                        foundCorrect = true;
                        break;
                    }
                    index++;
                }
            }
            if (foundCorrect) {
                data.correct = true;
                data.correctIndex = index;
            }
            else {
                data.incorrect = true;
            }
        }
        else if (models_1.EQuestionType.EXTENDED_MATCHING_ANSWER === mark.question.typeId) {
            const extendedAnswer = answer;
            const attempt = jsonAnswer;
            if (extendedAnswer.length !== attempt.length) {
                data.incorrect = true;
            }
            else {
                const map1 = createHashMap(extendedAnswer);
                const map2 = createHashMap(attempt);
                for (const [key, value] of map1) {
                    if (map2.get(key) !== value) {
                        data.incorrect = true;
                        break;
                    }
                }
                if (!data.incorrect) {
                    data.correct = true;
                }
            }
        }
        else if (models_1.EQuestionType.SELECT_THREE_ANSWER === mark.question.typeId) {
            const threeAnswer = answer;
            const attempt = jsonAnswer;
            if (threeAnswer.length !== 3) {
                data.incorrect = true;
            }
            else {
                const answerSet = new Set(threeAnswer);
                for (const attemptLabel of attempt) {
                    if (!answerSet.has(attemptLabel)) {
                        data.incorrect = true;
                        break;
                    }
                }
                if (!data.incorrect) {
                    data.correct = true;
                }
            }
        }
        else if (models_1.EQuestionType.RANKING_ANSWER === mark.question.typeId) {
            // Duplicate logic to Extended Matching, but they have different scoring systems
            // which we may add at a later point
            const rankAnswer = answer;
            const attempt = jsonAnswer;
            if (rankAnswer.length !== attempt.length) {
                data.incorrect = true;
            }
            else {
                for (let i = 0; i < rankAnswer.length; i++) {
                    if (rankAnswer[i] !== attempt[i]) {
                        data.incorrect = true;
                        break;
                    }
                }
                if (!data.incorrect) {
                    data.correct = true;
                }
            }
        }
        else if (models_1.EQuestionType.SJT_TWO_ANSWERS === mark.question.typeId) {
            const twoAnswer = answer;
            const attempt = jsonAnswer;
            if (twoAnswer.length !== 2 || attempt.length !== 2) {
                data.incorrect = true;
            }
            else if (twoAnswer.join(',') !== attempt.join(',')) {
                data.incorrect = true;
            }
            else {
                data.correct = true;
            }
        }
    }
    catch (e) {
        console.error(e);
    }
    return data;
}
exports.correctMark = correctMark;
